import Member from "../layout/Protected/Member"
import { Route } from "react-router-dom"
import Layout from "../layout/member"

// Dashboard layout
import Dashboard from "../pages/Member/Dashboard"

// Dashboard components
import BlogComments from "../components/dashboard/Blogs/BlogComments"
import ForumComment from "../components/dashboard/Forum/ForumComment"
import EditComment from "../components/dashboard/Drafts/EditComment"

import ForumLikes from "../components/dashboard/Forum/ForumLikes"
import EditForum from "../components/dashboard/Forum/EditForum"
import EditProfile from "../pages/Member/Dashboard/EditProfile"
import AddForum from "../components/dashboard/Forum/AddForum"
import AllForum from "../components/dashboard/Forum/AllForum"
import Bookings from "../pages/Member/Dashboard/bookings"
import Details from "../pages/Member/Dashboard/Details"
import Messages from "../components/dashboard/Messages"
import Password from "../components/dashboard/Password"
import Draft from "../components/dashboard/Drafts"
import Payments from "../pages/Member/Dashboard/payments"

// Appointments components
import AcceptedAppointments from "../pages/Member/Dashboard/appointments/accepted"
import PendingAppointments from "../pages/Member/Dashboard/appointments/pending"
import PastAppointments from "../pages/Member/Dashboard/appointments/past"
import Appointment from "../pages/Member/Dashboard/appointments"

// Specialist components
import Single from "../pages/Member/Dashboard/my-specialists/specialist-details"
import Specialist from "../pages/Member/Dashboard/my-specialists"
import Subscription from "pages/Member/subscription/Subscription"
import FeatureGuard from "../components/subscription/FeatureGuard"

const MemberRoutes = (
  <Route path="/member" element={<Layout />}>
    <Route path="profile" element={<Member><Dashboard /></Member>}>
      <Route path="" element={<Details />} />
      <Route path="draft" element={<Draft />} />
      <Route path="messages" element={<Messages />} />
      <Route path="appointment-messages" element={<Messages isAppointmentChat={true} />} />
      <Route path="all-forum" element={<AllForum />} />
      <Route path="add-forum" element={<AddForum />} />
      <Route path="forum-likes" element={<ForumLikes />} />
      <Route path="payments" element={<Payments />} />
      <Route path="subscription" element={<Subscription />} />
      <Route path="change-password" element={<Password />} />
      <Route path="edit-profile" element={<EditProfile />} />
      <Route path="edit-forum/:id" element={<EditForum />} />
      <Route path="blog-comments" element={<BlogComments />} />
      <Route path="forum-comments" element={<ForumComment />} />
      <Route path="edit-comment/:id" element={<EditComment />} />
      <Route path="booked-webinar/:type" element={<Bookings />} />

      <Route path="specialists" element={<Specialist />} />

      <Route
        path="specialist/:id"
        element={
          <FeatureGuard feature="SPECIALIST_PROFILE_VIEW">
            <Single />
          </FeatureGuard>
        }
      />

      <Route path="appointment" element={<Appointment />}>
        <Route path="past" element={<PastAppointments />} />
        <Route path="pending" element={<PendingAppointments />} />
        {/* <Route path="accepted" element={<AcceptedAppointments />} /> */}
        <Route path="upcoming" element={<AcceptedAppointments />} />

      </Route>
    </Route>
  </Route>
)

export default MemberRoutes